import React, { MouseEvent, useCallback, useEffect, useState } from 'react';
import { Modal } from '../../components';
import * as eventTracker from '../../utils/EventTracker';

import styles from './style.module.scss';

interface Props {
  open: boolean;
  drugList: {
    /** 药品 ID */
    id: number | string;
    /** 通用名 */
    genericName: string;
    /** 商品名 */
    tradeName: string;
    /** 数量 */
    quantity: number;
  }[];
  /** 处方 ID */
  prescriptionId: number;
  onCancel: (e: MouseEvent<HTMLButtonElement>) => void;
  onSubmit: (e: MouseEvent<HTMLButtonElement>) => void;
}

/**
 * 获取药品完整名称
 *
 * @param {string} genericName 通用名
 * @param {string} [tradeName] 商品名
 * @returns {string} [商品名]通用名 or 通用名
 */
const getDrugName = (genericName: string, tradeName?: string): string => {
  return tradeName ? `[${tradeName}]${genericName}` : genericName;
};

function ConfirmDrugInfoModal(props: Props) {
  const { open, drugList, onCancel, onSubmit, prescriptionId } = props;
  const [clicked, setClicked] = useState(false);
  const handleSubmit = useCallback(
    (e: MouseEvent<HTMLButtonElement>) => {
      e.stopPropagation();

      if (!clicked) {
        eventTracker.track('clickSubmitButtonInReBuyDrugInfoModal', {
          prescriptionId: prescriptionId.toString(),
        });
      }
      setClicked(true);
      onSubmit(e);
    },
    [clicked, onSubmit, prescriptionId]
  );

  const handleCancel = useCallback(
    (e: MouseEvent<HTMLButtonElement>) => {
      e.stopPropagation();

      if (!clicked) {
        eventTracker.track('clickCancelButtonInReBuyDrugInfoModal', {
          prescriptionId: prescriptionId.toString(),
        });
      }
      setClicked(true);

      onCancel(e);
    },
    [clicked, onCancel, prescriptionId]
  );

  useEffect(() => {
    if (open) {
      eventTracker.track('viewConfirmDrugInfoModal', {
        prescriptionId: prescriptionId.toString(),
      });
      setClicked(false);
    }
  }, [open, prescriptionId]);

  return (
    <Modal open={open} archor="center" tapMaskClose={false}>
      <div className={styles.contentWrapper}>
        <div className={styles.contentTitle}>请确认购药信息</div>

        <div>
          {drugList.map(drug => (
            <div className={styles.contentDrugContainer} key={drug.id}>
              <span className={styles.contentDrugContainerName}>
                {getDrugName(drug.genericName, drug.tradeName)}
              </span>
              <span>x{drug.quantity}</span>
            </div>
          ))}
        </div>

        <div className={styles.contentFooter}>
          <button onClick={handleCancel}>再想想</button>
          <button onClick={handleSubmit}>发送购药申请</button>
        </div>
      </div>
    </Modal>
  );
}

export default ConfirmDrugInfoModal;
